"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    name: {
        id: "ktx.header.name",
        defaultMessage: "Páciens neve"
    },
    status: {
        id: "ktx.header.status",
        defaultMessage: "Státusz"
    },
    waitingList: {
        id: "ktx.header.waiting_list",
        defaultMessage: "Várólistán"
    },
    patientEtId: {
        id: "ktx.header.patient_et_id",
        defaultMessage: "ET azonosító"
    },
    renalReplacementTherapy: {
        id: "ktx.header.renal_replacement_therapy",
        defaultMessage: "Vesepótló kezelés"
    },
    dm: {
        id: "ktx.header.dm",
        defaultMessage: "DM"
    },
    liveDonorScreening: {
        id: "ktx.header.live_donor_screening",
        defaultMessage: "Élő donor kivizsgálás"
    },
    ht: {
        id: "ktx.header.ht",
        defaultMessage: "HT"
    },
    nephrologistOpinion: {
        id: "ktx.header.nephrologist_opinion",
        defaultMessage: "Nefrológus véleménye"
    },
    kidneyDiseaseEthiology: {
        id: "ktx.header.kidney_disease_ethiology",
        defaultMessage: "Alapbetegség"
    },
    dialysisCentre: {
        id: "ktx.header.dialysis_centre",
        defaultMessage: "D. C."
    },
    transplantAnesthesiology: {
        id: "ktx.header.transplant_anesthesiology",
        defaultMessage: "T. Aneszt."
    },
    transplantSurgery: {
        id: "ktx.header.transplant_surgery",
        defaultMessage: "T. Sebészet"
    },
    transtorachalisEcho: {
        id: "ktx.header.transtorachalis_echo",
        defaultMessage: "T. ECHO"
    },
    abdominalPelvisUltrasound: {
        id: "ktx.header.abdominal_pelvis_ultrasound",
        defaultMessage: "Has-kism. uh"
    },
    ssn: {
        id: "ktx.header.social_security_number",
        defaultMessage: "TAJ"
    },
    address: {
        id: "ktx.header.address",
        defaultMessage: "Lakhely"
    },
    phoneNumber: {
        id: "ktx.header.phone_number",
        defaultMessage: "Telefon"
    },
    bloodGroup: {
        id: "ktx.header.blood_group",
        defaultMessage: "Vércsoport"
    },
    age: {
        id: "ktx.header.age",
        defaultMessage: "Életkor"
    },
    weight: {
        id: "ktx.header.weight",
        defaultMessage: "Testsúly"
    },
    height: {
        id: "ktx.header.height",
        defaultMessage: "Magasság"
    },
    bmi: {
        id: "ktx.header.bmi",
        defaultMessage: "BMI"
    },
    dashboard: {
        id: "ktx.header.dashboard",
        defaultMessage: "Dashboard"
    },
    editPatient: {
        id: "ktx.header.edit_patient",
        defaultMessage: "Páciens adatainak szerkesztése"
    },
    timeline: {
        id: "ktx.header.timeline",
        defaultMessage: "Idővonal"
    },
    report: {
        id: "ktx.header.report",
        defaultMessage: "Riport"
    },
    pdf: {
        id: "ktx.header.pdf",
        defaultMessage: "OVSZ recipiens bejelentő"
    },
    prevTrans: {
        id: "ktx.header.prevTrans",
        defaultMessage: "Előző Tx"
    },
    prevTransKidney: {
        id: "ktx.header.prevTransKidney",
        defaultMessage: "Vese"
    },
    prevTransLiver: {
        id: "ktx.header.prevTransLiver",
        defaultMessage: "Máj"
    },
    prevTransHeart: {
        id: "ktx.header.prevTransHeart",
        defaultMessage: "Szív"
    },
    prevTransLung: {
        id: "ktx.header.prevTransLung",
        defaultMessage: "Tüdő"
    },
    prevTransPancreas: {
        id: "ktx.header.prevTransPancreas",
        defaultMessage: "Pancreas"
    },
    prevTransBoneMarrow: {
        id: "ktx.header.prevTransBoneMarrow",
        defaultMessage: "Csontvelő"
    },
    prevTransOther: {
        id: "ktx.header.prevTransOther",
        defaultMessage: "Egyéb"
    }
};
